import HttpMethods from '../enums/HttpMethods'
import WebService from './WebService'

class LoginService {

    connect(username, password) {
        return WebService.call('/api/login', HttpMethods.POST, {username: username, password: password})
    }

    disconnect() {
        return WebService.call('/api/auth/logout', HttpMethods.POST)
    }

}

export default new LoginService();



// WEBPACK FOOTER //
// ./src/services/LoginService.js